export const _en = {
    id: {
        label: "Id"
    },
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    isSimulator: {
        label: "Is simulator type"
    },
    isInstructor: {
        label: "Is instructor type"
    },
    isTimeSettingActivated: {
        label: "Activate time setting",
        tooltip: "Activate time setting"
    },
    resourceCategory: {
        label: "Resource category"
    },
    refDivisionId: {
        label: "Division"
    }
};

export const _fr = {
    id: {
        label: "Id"
    },
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    isSimulator: {
        label: "Est de type simulateur"
    },
    isInstructor: {
        label: "Est de type instructeur"
    },
    counterKpi1: {
        label: "Compteur AFCA KPI n°1",
        tooltip: "Affiche le nombre d'heures d'engagements des RMs AFCA"
    },
    counterKpi2: {
        label: "Compteur AFCA KPI n°2",
        tooltip: "Affiche la moyenne (hebdomadaire et mensuelle) du nombre d'heures d'activités pratiquées devant stagiaires"
    },
    counterAto: {
        label: "Compteurs ATO",
        tooltip: "Affiche la liste des compteurs ATO"
    },
    isTimeSettingActivated: {
        label: "Activer un calage horaire",
        tooltip: "Un calage horaire permet de définir des heures de débuts d'affectation à respecter pour toute(s) ressource(s) de ce type"
    },
    resourceCategory: {
        label: "Catégorie de ressource"
    },
    refDivisionId: {
        label: "Service"
    }
};